import { useEffect, useState } from 'react';

/** Below this width, sidebars move into the hamburger drawer. */
export const COMPACT_SIDEBAR_MAX_WIDTH = 1200;

/** Landscape tablets (e.g. iPad Pro) can be wider than 1200px but still need the drawer. */
export const COMPACT_LANDSCAPE_MAX_WIDTH = 1400;
export const COMPACT_LANDSCAPE_MAX_HEIGHT = 920;

export function shouldUseCompactSidebarLayout(): boolean {
  if (typeof window === 'undefined') return true;

  const w = window.innerWidth;
  const h = window.innerHeight;

  if (w <= COMPACT_SIDEBAR_MAX_WIDTH) return true;

  // Landscape: wide but short viewport — three columns don't fit comfortably
  if (w > h && w <= COMPACT_LANDSCAPE_MAX_WIDTH && h <= COMPACT_LANDSCAPE_MAX_HEIGHT) {
    return true;
  }

  return false;
}

export function useCompactSidebarLayout(): boolean {
  const [compact, setCompact] = useState(shouldUseCompactSidebarLayout);

  useEffect(() => {
    const update = () => setCompact(shouldUseCompactSidebarLayout());
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return compact;
}
